import React, { useState } from 'react'
import { Table, Button, Form, Modal, message, Avatar } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import PracticeColorForm from './PracticeColorForm'

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const PracticeColor = ({
  colors,
  loading,
  addPracticeColorHandler,
  updatePracticeColorHandler,
  deletePracticeColorHandler
}) => {
  const [form] = Form.useForm()
  const [formForEdit] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [colorItem, setPracticeColorItem] = React.useState(null)
  const [editModal, setEditModal] = React.useState(false)
  const [deleteModal, setDeleteModal] = React.useState(false)

  const [audioFile, setAudioFile] = useState(null)
  const audioFileRef = React.useRef()

  const [imageFile, setImageFile] = useState(null)
  const imageFileRef = React.useRef()

  const [mergeImageFile, setMergeImageFile] = useState(null)
  const mergeImageFileRef = React.useRef()

  const [objectFile, setObjectFile] = useState(null)
  const objectFileRef = React.useRef()

  const columns = [
    {
      title: '',
      width: '1%',
      render: item => <div style={{ background: item.status === 'active' ? '#44FB82' : '#D4D4D4', height: '60px', width: '20px', margin: '-10px' }}></div>
    },
    {
      title: '',
      width: '1%',
      dataIndex: 'index'
    },
    {
      title: 'Цвет',
      width: '5%',
      render: item => <div style={{ backgroundColor: '#' + item.code, height: '60px', width: '40px', margin: '-10px' }}></div> 
    },
    {
      title: 'Дорожка',
      width: '5%',
      render: item => {
        let audioLink = item.audioURL
        if (!audioLink.startsWith('https://')) {
          audioLink = 'https://' + audioLink
        }
        return (
          <audio controls="controls">
            <source src={audioLink} type="audio/mpeg" />
          </audio>
        )
      }
    },
    {
      title: 'Фото',
      render: item => <Avatar shape="square" size={64} src={item.imageURL} />
    },
    {
      title: 'Слияние цветов',
      render: item => <Avatar shape="square" size={64} src={item.mergeImageURL} />
    },
    {
      title: 'Объект',
      render: item => <Avatar shape="square" size={64} src={item.objectURL} />
    },
    {
      title: 'Цвет',
      dataIndex: 'name',
      width: '10%'
    },
    {
      title: 'Действие',
      width: '20%',
      render: item => (
        <>
          <span>
            <Button
              type="link"
              onClick={() => {
                formForEdit.resetFields()
                setEditModal(true)
                setPracticeColorItem(item)
              }}>
              Редактировать
            </Button>
            <Button
              danger
              type="link"
              onClick={() => {
                setDeleteModal(true)
                setPracticeColorItem(item)
              }}>
              Удалить
            </Button>
          </span>
        </>
      )
    }
  ]

  return (
    <>
      <Table
        dataSource={colors}
        columns={columns}
        rowKey={item => item.id}
        loading={loading}
        pagination={{
          showSizeChanger: false
        }}
        title={() => (
          <StyledHeaderContainer>
            <Button type="primary" onClick={() => setModalVisible(true)}>
              <PlusOutlined /> Новый цвет
            </Button>
          </StyledHeaderContainer>
        )}
      />
      <Modal
        open={modalVisible}
        title="Новаый цвет"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
          setAudioFile(null)
          setImageFile(null)
          audioFileRef.current.value = null
          imageFileRef.current.value = null
          setMergeImageFile(null)
          mergeImageFileRef.current.value = null
          setObjectFile(null)
          objectFileRef.current.value = null
        }}
        onOk={() => {
          if (audioFile !== null) {
            addPracticeColorHandler(
              form,
              setModalVisible,
              audioFile,
              audioFileRef,
              setAudioFile,
              imageFile,
              imageFileRef,
              setImageFile,
              mergeImageFile,
              mergeImageFileRef,
              setMergeImageFile,
              objectFile,
              objectFileRef,
              setObjectFile
            )
          } else {
            message.error('Пожалуйста, выберите Аудио файл')
          }
        }}
      >
        <PracticeColorForm
          setAudioFile={setAudioFile}
          audioFileRef={audioFileRef}
          setImageFile={setImageFile}
          imageFileRef={imageFileRef}
          setMergeImageFile={setMergeImageFile}
          mergeImageFileRef={mergeImageFileRef}
          setObjectFile={setObjectFile}
          objectFileRef={objectFileRef}
          form={form}
        />
      </Modal>
      {editModal && (
        <Modal
          open={editModal}
          onCancel={() => {
            setEditModal(false)
            setAudioFile(null)
            audioFileRef.current.value = null
            setImageFile(null)
            imageFileRef.current.value = null
            setMergeImageFile(null)
            mergeImageFileRef.current.value = null
            setObjectFile(null)
            objectFileRef.current.value = null
          }}
          onOk={() => {
            updatePracticeColorHandler(
              formForEdit,
              colorItem.id,
              setEditModal,
              audioFile,
              audioFileRef,
              setAudioFile,
              imageFile,
              imageFileRef,
              setImageFile,
              mergeImageFile,
              mergeImageFileRef,
              setMergeImageFile,
              objectFile,
              objectFileRef,
              setObjectFile
            )
          }}
        >
          <PracticeColorForm
            form={formForEdit}
            index={colorItem.index}
            name={colorItem.name}
            code={colorItem.code}
            status={colorItem.status}
            setAudioFile={setAudioFile}
            audioFileRef={audioFileRef}
            setImageFile={setImageFile}
            imageFileRef={imageFileRef}
            mergeImageFileRef={mergeImageFileRef}
            setMergeImageFile={setMergeImageFile}
            objectFileRef={objectFileRef}
            setObjectFile={setObjectFile}
          />
        </Modal>
      )}
      {deleteModal && (
        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false)
          }}
          onOk={() =>
            deletePracticeColorHandler(colorItem.id, setDeleteModal)
          }
        >
          <h3>Вы действительно хотите удалить '{colorItem.color}' ?</h3>
        </Modal>
      )}
    </>
  )
}

PracticeColor.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.object).isRequired,
  addPracticeColorHandler: PropTypes.func.isRequired,
  updatePracticeColorHandler: PropTypes.func.isRequired
}

export default PracticeColor
